























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_subUnit_subUnit } from '../../queries/__generated__/subUnit';
import SubUnitShow from '@/components/SubUnit/SubUnitShow.vue';

@Component({
  components: {
    SubUnitShow,
  },
})
export default class SubUnitShowButton extends Vue {
  @Prop() private subUnit!: GQL_subUnit_subUnit;
  private showDialog = false;
}
